export const EQUALS_CARDS_ERROR_MESSAGES_BY_CODE = {
  // Validation errors
  MISSING_FIELDS: {
    en: 'Missing required fields: {fields}',
    fr: 'Champs obligatoires manquants : {fields}',
  },
  INVALID_CARD_TYPE: {
    en: 'Invalid card type. Must be "budget_card" or "individual_card"',
    fr: 'Type de carte invalide. Doit être "budget_card" ou "individual_card"',
  },
  INVALID_STATE: {
    en: 'Invalid state. Must be one of: active, suspended, terminated',
    fr: 'État invalide. Doit être : active, suspended, terminated',
  },
  INVALID_PIN: {
    en: 'PIN must be exactly 4 digits',
    fr: 'Le PIN doit comporter exactement 4 chiffres',
  },
  WEAK_PIN: {
    en: 'PIN is too weak. Avoid identical digits or consecutive sequences.',
    fr: 'Le code PIN est trop faible. Évitez les chiffres identiques ou les séquences consécutives.',
  },
  INDIVIDUAL_CARD_LIMIT_EXCEEDED: {
    en: 'This user already has an active individual card for this company.',
    fr: 'Cet utilisateur possède déjà une carte individuelle active pour cette entreprise.',
  },
  INVALID_OTP_FORMAT: {
    en: 'Code must be a 6-digit number',
    fr: 'Le code doit être un nombre à 6 chiffres',
  },
  CARD_NAME_TOO_LONG: {
    en: 'Card name must be 40 characters or fewer',
    fr: 'Le nom de la carte ne doit pas dépasser 40 caractères',
  },
  INVALID_STATUS_FILTER: {
    en: 'Status filter must be "active" or "archived"',
    fr: 'Le filtre de statut doit être "active" ou "archived"',
  },
  INVALID_VIEW: {
    en: 'View must be "own" or "all"',
    fr: 'La vue doit être "own" ou "all"',
  },

  // Business/service errors
  CARD_NOT_FOUND: {
    en: 'Card not found',
    fr: 'Carte introuvable',
  },
  EQUALS_ACCOUNT_NOT_FOUND: {
    en: 'No Equals account found',
    fr: 'Aucun compte Equals trouvé',
  },
  EQUALS_PERSON_NOT_FOUND: {
    en: 'No Equals person found for this user',
    fr: 'Aucun profil Equals trouvé pour cet utilisateur',
  },

  // OTP errors (update_pin / access-token)
  OTP_NOT_FOUND: {
    en: 'OTP not found',
    fr: 'Code OTP introuvable',
  },
  OTP_ALREADY_USED: {
    en: 'Code has already been used',
    fr: 'Le code a déjà été utilisé',
  },
  OTP_MAX_ATTEMPTS: {
    en: 'Maximum attempts exceeded',
    fr: 'Nombre maximum de tentatives dépassé',
  },
  OTP_EXPIRED: {
    en: 'Code has expired',
    fr: 'Le code a expiré',
  },
  OTP_INVALID_CODE: {
    en: 'Invalid code. Remaining attempts: {n}',
    fr: 'Code invalide. Tentatives restantes : {n}',
  },
  OTP_SYSTEM_ERROR: {
    en: 'An error occurred. Please try again later.',
    fr: 'Une erreur est survenue. Veuillez réessayer plus tard.',
  },
};

function normalizeLocale(locale) {
  return locale === 'en' ? 'en' : 'fr';
}

function interpolate(template, params) {
  if (!template || !params) return template;
  return template.replace(/\{(\w+)\}/g, (m, k) => {
    const v = params[k];
    if (v === undefined || v === null) return m;
    if (Array.isArray(v)) return v.join(', ');
    return String(v);
  });
}

function parseRemainingAttemptsFromMessage(error) {
  const msg =
    error?.message || error?.msg || error?.error_message || error?.errorMessage;
  if (!msg) return undefined;

  const en = String(msg).match(/remaining attempts\s*:\s*(\d+)/i);
  if (en?.[1]) return Number(en[1]);

  const fr = String(msg).match(/tentatives restantes\s*:\s*(\d+)/i);
  if (fr?.[1]) return Number(fr[1]);

  return undefined;
}

function extractParams(error) {
  const ctx = error?.error_context || error?.context || {};

  const fields =
    error?.fields ??
    ctx?.fields ??
    ctx?.missing_fields ??
    ctx?.missingFields ??
    undefined;

  const n =
    error?.n ??
    error?.remaining_attempts ??
    error?.remainingAttempts ??
    ctx?.n ??
    ctx?.remaining_attempts ??
    ctx?.remainingAttempts ??
    parseRemainingAttemptsFromMessage(error) ??
    undefined;

  return {fields, n};
}

export function isEqualsCardsApi(api) {
  if (typeof api !== 'string') return false;
  return api.includes('equals/cards');
}

export function resolveEqualsCardsErrorMessage({api, error, locale} = {}) {
  const loc = normalizeLocale(locale);
  const code = error?.error_code || error?.code || error?.errorCode;
  if (!code) return null;

  // Only apply this mapping to equals/cards endpoints
  if (!isEqualsCardsApi(api)) return null;

  const msg = EQUALS_CARDS_ERROR_MESSAGES_BY_CODE?.[code]?.[loc];
  if (!msg) return null;

  return interpolate(msg, extractParams(error));
}
